import comp from './RunExam'

export * from './RunExam'

export default comp


